import React from 'react';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';

const OrderButton = ({ triggerText, buttonRef, showModal }) => {
    return (
        <Button
            variant="primary"
            ref={buttonRef}
            onClick={showModal}
            type={"button"}
        >
            {triggerText}
        </Button>
    );
};
export default OrderButton;